"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationOverviewInfoFlightsCard = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const rateTypeMapper_1 = require("../../../../PriceVariant/rateTypeMapper");
require("./index.scss");
const className = 'reservation-overview-info-flights-card';
const ReservationOverviewInfoFlightsCard = (props) => {
    const { rateTariffType, originAirportName, destinationAirportName, flightNumber, departureDateTimes, } = props;
    const classNames = (0, classnames_1.default)(className, props.className, { [`${className}--green`]: rateTypeMapper_1.rateTypeToModifierMap[rateTariffType] === 'green' }, { [`${className}--blue`]: rateTypeMapper_1.rateTypeToModifierMap[rateTariffType] === 'blue' });
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("p", { className: `${className}__airports` },
            originAirportName,
            " \u2013 ",
            destinationAirportName),
        react_1.default.createElement("p", { className: `${className}__flight-info` },
            react_1.default.createElement("span", { className: `${className}__flight-number` }, flightNumber),
            "\u00A0",
            react_1.default.createElement("span", { className: `${className}__date` }, departureDateTimes),
            "\u00A0",
            react_1.default.createElement("span", { className: `${className}__tariff` }, rateTariffType))));
};
exports.ReservationOverviewInfoFlightsCard = ReservationOverviewInfoFlightsCard;
//# sourceMappingURL=index.js.map